import { render, staticRenderFns } from "./AmountGroup-gt3.vue?vue&type=template&id=61b9a31e&scoped=true"
import script from "./AmountGroup-gt3.vue?vue&type=script&lang=js"
export * from "./AmountGroup-gt3.vue?vue&type=script&lang=js"
import style0 from "./AmountGroup-gt3.vue?vue&type=style&index=0&id=61b9a31e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b9a31e",
  null
  
)

export default component.exports